import { jsx as _jsx } from "react/jsx-runtime";
import cn from "variant-classnames";
import cx from "classnames";
const variants = {
    $all: cx("relative rounded-full bg-gray-200 animation-delay-500 animate-dot-flashing", "dark:bg-gray-600 dark:animate-dot-flashing-dark dark:animation-delay-500", "before:inline-block before:absolute before:top-0 before:rounded-full before:bg-gray before:animation-delay-none before:animate-dot-flashing", "dark:before:animation-delay-none dark:before:animate-dot-flashing-dark dark:before:gray-600", "after:inline-block after:absolute after:top-0 after:rounded-full after:bg-gray-200 after:animation-delay-1000 after:animate-dot-flashing", "dark:after:animation-delay-1000 dark:after:animate-dot-flashing-dark dark:after:bg-gray-600"),
    size: {
        xsmall: cx("w-1 h-1", "before:w-1 before:h-1 before:-left-2", "after:w-1 after:h-1 after:left-2"),
        small: cx("w-2 h-2", "before:w-2 before:h-2 before:-left-5", "after:w-2 after:h-2 after:left-5"),
        medium: cx("w-3 h-3", "before:w-3 before:h-3 before:-left-8", "after:w-3 after:h-3 after:left-8"),
        large: cx("w-6 h-6", "before:w-6 before:h-6 before:-left-14", "after:w-6 after:h-6 after:left-14"),
    },
};
/**
 * The Loader component is a simple loading spinner UI element. It provides
 * customizable sizing options to better suit various use cases and designs.
 *
 * @component
 * @param {ILoaderProps} props - The props for the Loader component.
 * @param {string} [props.size] - The size of the loading spinner. Available options are "xsmall", "small", "medium", and "large". Default is "medium".
 * @param {string} [props.className] - Additional CSS classes to be applied to the Loader component.
 * @returns {JSX.Element} A rendered Loader component.
 */
const Loader = ({ className, size = "medium" }) => {
    const classes = cn(variants, { className, size });
    return _jsx("div", { className: classes });
};
export default Loader;
//# sourceMappingURL=Loader.js.map